import script from "./sf-table-header-cell.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-table-header-cell.vue?vue&type=script&setup=true&lang=ts"

import "./sf-table-header-cell.vue?vue&type=style&index=0&id=f12f277d&lang=scss"

const __exports__ = script;

export default __exports__